import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    AddonTaskFilterInput,
    CreateAddonTaskInput,
    InitializeAddonTaskCheckoutInput,
    UpdateAddonTaskInput,
} from './inputs';
import { AddonTaskResource } from './resources';
import { AddonTaskCheckoutRef, AddonTaskRef } from './refs';

export default class AddonTask {
    private basePath = '/api/addon-task';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of addon tasks
    get = async (filter: AddonTaskFilterInput): Promise<CollectionResource<AddonTaskResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });
        const { data } = await this.http.get(`${this.basePath}/?${query}`);
        return data;
    };

    // Initialize addon task checkout
    initializeCheckout = async (input: InitializeAddonTaskCheckoutInput): Promise<AddonTaskCheckoutRef> => {
        const { data } = await this.http.post(`${this.basePath}/checkout`, input);
        return data;
    };

    // Attempt addon task checkout finalization
    attemptCheckoutFinalization = async (addonTaskCheckoutId: ID): Promise<AddonTaskCheckoutRef> => {
        const { data } = await this.http.post(`${this.basePath}/checkout/${addonTaskCheckoutId}/attempt`);
        return data;
    };

    // Create new addon task
    create = async (input: CreateAddonTaskInput): Promise<AddonTaskRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Update addon task
    update = async (id: ID, input: UpdateAddonTaskInput): Promise<AddonTaskRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);
        return data;
    };

    // Archive addon task (manual only)
    archive = async (id: ID): Promise<AddonTaskRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);
        return data;
    };

    // Restore archived addon task
    restore = async (id: ID): Promise<AddonTaskRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);
        return data;
    };
}
